<div class="animated fadeInRight">
  <app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false"
    (devolverAccion)="downloadDataCsv()">
  </app-lfsa-card>

  <ng-template #enviarTemplate>
    <h2 class="container float-left">{{ tituloForm }}</h2>
    
    <div class="row form-group">
      <div class="form-group col-md-9">
        <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
          (keyup)="onQuickFilterChanged() " #quickFilter />
      </div>
      <div class="form-group col-md-3">
        <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
          [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
          [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>
</div>

<!--
<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
-->

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'"
  [innTemplate]="enviarTemplateResport" [titulo]="'Presupuesto Jerarquia Propiedades'"></app-lfsa-modal>

<ng-template #enviarTemplateResport>
  <!-- {{ formulario.value | json }} -->
    <div class="container-fluid">
      <div [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
          <div class="form-group col-md-4">
            <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbAnio"
              formControlName="anio" [control]="formulario.get('anio')" [label]="'Año*'" [id]="'anio'" [habilitar]="editableForm">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-4">
            <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
              [comboBox]="cmbPeriodo" formControlName="mes" [control]="formulario.get('mes')" [label]="'Mes*'" [id]="'mes'" [habilitar]="editableForm" >
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-4">
            <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Usuario'"
              [label]="'Usuario*'" [id]="'usuario'" [formControlName]="'usuario'"
              [control]="formulario.get('usuario')"></app-lfsa-input>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-3">
            <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código del Vendedor'"
              [label]="'Vendedor*'" [id]="'codigoVendedor'" [formControlName]="'codigoVendedor'"
              [control]="formulario.get('codigoVendedor')" (change)="onChangeVendedor($event);" [isReadOnly]="editableForm"
              (keyup)="onChangeVendedor($event);"></app-lfsa-input>
          </div>
          <div class="form-group col-md-9">
            <app-lfsa-input [isReadOnly]="editableForm" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Nombre Vendedor'"
              [label]="'Nombre Vendedor*'" [id]="'nombreVendedor'" [formControlName]="'nombreVendedor'"
              [control]="formulario.get('nombreVendedor')"></app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código del Material'"
              [label]="'Material*'" [id]="'material'" [formControlName]="'material'" [control]="formulario.get('material')" [isReadOnly]="editableForm"
              (change)="onChangeMaterial($event);" (keyup)="onChangeMaterial($event);"></app-lfsa-input>
          </div>
          <div class="form-group col-md-9">
            <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Nombre Material'"
              [label]="'Nombre Material*'" [id]="'nombreMaterial'" [formControlName]="'nombreMaterial'" [isReadOnly]="editableForm"
              [control]="formulario.get('nombreMaterial')"></app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código SubCategoria-Jerarquia'"
              [label]="'Jerarquia*'" [id]="'jerarquia'" [formControlName]="'jerarquia'" [isReadOnly]="true"
              [control]="formulario.get('jerarquia')"></app-lfsa-input>
          </div>
          <div class="form-group col-md-9">
            <app-lfsa-input  [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Nombre Jerarquia-Subcategoria'"
              [label]="'Nombre Jerarquia-Subcategoria*'" [id]="'jerarquiaDescripcion'" [formControlName]="'jerarquiaDescripcion'" [isReadOnly]="true"
              [control]="formulario.get('jerarquiaDescripcion')"></app-lfsa-input>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-12 col-md-4">
            <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Número de Cajas'"
              [label]="'Cajas'" [id]="'cajas'" [formControlName]="modelGrid.cajas"
              [control]="formulario.get(modelGrid.cajas)"></app-lfsa-input>
          </div>
          <div class="form-group col-12 col-md-4">
            <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese el peso en Kilos'"
              [label]="'Kilos'" [id]="'kilos'" [formControlName]="modelGrid.kilos"
              [control]="formulario.get(modelGrid.kilos)"></app-lfsa-input>
          </div>
          <div class="form-group col-12 col-md-4">
            <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese el monto en Dolares'"
              [label]="'Dolares'" [id]="'dolares'" [formControlName]="modelGrid.dolares"
              [control]="formulario.get(modelGrid.dolares)"></app-lfsa-input>
          </div>
        </div>

        <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
          [textBoton]="textBoton"></app-lfsa-botones-formulario>
      </div>
  </div>
</ng-template>
<!-- END MODAL -->

